import ELInspectionsReportUploadModal from "./ELInspectionsReportUploadModal";

export default ELInspectionsReportUploadModal;
